import script from "./CompanyHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyHistory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__